import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import colors from '@legacy/moon/particles/colors';

const defaultColors = [colors.moonlight90, colors.borealis60, colors.borealis60];

const iconFill = Object.freeze({
  light: [colors.moonlight0, colors.moonlight20, colors.moonlight20],
  dark: [colors.darkThree, colors.borealis60, colors.borealis60],
  alpha: defaultColors,
});

const UpAndDownArrows = (props: Record<string, unknown>): JSX.Element => {
  // @ts-ignore
  const { product }: BitsoGlobals.LegacyTheme = useContext(ThemeContext);

  const fill = iconFill[product] || defaultColors;

  return (
    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" fill={fill[0]} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m13.5 14.828-3.086 3.086L9 16.5l5.5-5.5 5.5 5.5-1.414 1.414-3.086-3.086V25h-2V14.828ZM26.5 25.172l3.086-3.086L31 23.5 25.5 29 20 23.5l1.414-1.414 3.086 3.086V15h2v10.172Z"
        fill={fill[1]}
      />
      <path
        d="M8 1h24v-2H8v2Zm31 7v24h2V8h-2Zm-7 31H8v2h24v-2ZM1 32V8h-2v24h2Zm7 7a7 7 0 0 1-7-7h-2a9 9 0 0 0 9 9v-2Zm31-7a7 7 0 0 1-7 7v2a9 9 0 0 0 9-9h-2ZM32 1a7 7 0 0 1 7 7h2a9 9 0 0 0-9-9v2ZM8-1a9 9 0 0 0-9 9h2a7 7 0 0 1 7-7v-2Z"
        fill={fill[2]}
      />
    </svg>
  );
};

export default UpAndDownArrows;
